export const INITIATE_REQUEST = 'articleOverview/INITIATE_REQUEST'
export const SET_ARTICLE_OVERVIEW = 'articleOverview/SET_ARTICLE_OVERVIEW'
export const SET_AVAILABLE_FILTER = 'articleOverview/SET_AVAILABLE_FILTER'
export const SET_ERROR_MESSAGE = 'articleOverview/SET_ERROR_MESSAGE'
export const SET_FILTER = 'articleOverview/SET_FILTER'
export const SET_ARTICLE_BLOCKED = 'articleOverview/SET_ARTICLE_BLOCKED'
export const RESET_FILTER = 'articleOverview/RESET_FILTER'
export const IGNORE_FILTER_WARNING = 'articleOverview/IGNORE_FILTER_WARNING'
